export default "__VITE_ASSET__Z21MQOGw__"